import { Component, OnInit, ChangeDetectorRef, ApplicationRef, ViewChild} from '@angular/core';
import { BaseService } from '../../../services/base.services';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import pageSettings from '../../../config/page-settings';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { formatDate} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { NgxChartsModule, id } from '@swimlane/ngx-charts';
import * as moment from 'moment';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import 'nvd3';
declare var Highcharts: any;
declare var nv: any;
import * as global from '../../../config/globals';
@Component({
  selector: 'standard',
  templateUrl: './standard.html',
  styleUrls: ['standard.css']
})

export class StandardPage implements OnInit{
  private data:Array<any> = [];
  pageSettings = pageSettings;
  listEspesadores: any = [];
  listMetricas: any = [];
  tareaSeleccionada: any;
  loading = false;
  cargando = false;
  menuMobile: any = [
    {
      Id: 1,
      Nombre: 'Home',
      Icono: 'fa-home',
      Href: '/gestionTareas',
    },
    {
      Id: 2,
      Nombre: 'Mantención',
      Icono: 'fa-cogs',
      Href: '/mantenciones',
    },
    {
      Id: 3,
      Nombre: 'Producción',
      Icono: 'fa-chart-bar',
      Href: '/produccion',
    },
    {
      Id: 4,
      Nombre: 'Actividades',
      Icono: 'fa-list-alt',
      Href: '/actividades',
    },
    {
      Id: 5,
      Nombre: 'Estandares',
      Icono: 'fa-server',
      Href: '/estandares',
    },    
  ];

  listEstandares: any = [
    {
      Titulo: 'Estándar FFCC',
      Descripcion: 'Se priorizará el vaciado de últimos trenes antes de la ventana por línea 1, muy importante mantener la comunicación entre despachador de trenes y CP 1, para asegurar la mejor estrategia de vaciado de trenes. FFCC T-8 dará prioridad al vaciado por línea 1 del primer tren de finos posterior a la ventana.'
    },
    {
      Titulo: 'Estándar crisis hídrica',
      Descripcion: 'Cp 59%, Si el Cp es menor a 60.5 y mayor a 58.5 ajusto Make up.'
    }
  ];
  menuSelected: any = 5;

  public constructor(
    private baseService: BaseService,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private cd : ChangeDetectorRef,
    private route: ActivatedRoute,
    private appRef: ApplicationRef,
    private config: NgbTabsetConfig
    ) {
        this.pageSettings.pageEmpty = false;
        this.pageSettings.pageWithoutSidebar = true;
        this.pageSettings.appSelected = null;
        config.justify = 'center';
        registerLocaleData( es );
  }

  async ngOnInit()  {


    this.GetEspesadores();
    this.GetMetricasDia();
  }

  async GetEspesadores(){
    try{
      this.cargando = true;
      var listEspesadores: any = await this.baseService.getEspesadores({}).toPromise();
      this.listEspesadores = listEspesadores.filter(x=> x.Metrica == "TORQUE" && x.Unidad == "%");
      console.log(this.listEspesadores);
      this.get_Comentarios();
      this.cargando = false;
    }catch(error){
      this.cargando = false;
      console.log(error);
    }
  }

  async add_ProdLog(item) {
    try {
      if(!item.comentario){
        this.toastr.error('Debe ingresar un comentario', 'No guardado');
        return;
      }
      console.log(item);
      var _storage = JSON.parse(localStorage.getItem('data'));
      console.log(_storage.usuario.IDUSUARIO);
      var index = this.listEspesadores.map(x=> x.Equipo).indexOf(item.Equipo);
      var respuesta = await this.baseService.add_ProdLog({IdEquipo: index, Fecha: moment().format("YYYY-MM-DD"), 
        IdUsuario: _storage.usuario.IDUSUARIO, 
        Comentario: item.comentario, Real: item.Torque}).toPromise();
     console.log(respuesta);
      this.toastr.success('Comentario guardado', '');
      item.agregarComentario = false;
    }catch(error){
      console.log(error);
    }
  }

  async get_Comentarios(){
    try{
      this.cargando = true;
      var comentarios: any = await this.baseService.get_Comentarios({IdEquipo: 0, IdTipo: 0}).toPromise();
      this.listEspesadores.forEach((e, index) => {
        comentarios.forEach(c => {
          if(c.idEquipo == index){
            e.comentario = c.Comentario;
          }
        });
      });
      this.cargando = false;
    }catch(error){
      this.cargando = false;
      console.log(error);
    }
  }

  async GetMetricasDia(){
    try{
      this.cargando = true;
      this.listMetricas = await this.baseService.GetMetricasDia({pivot:1, idMetricas: 97, idActivos:'', idDivisiones: 6,tipoValor: 3,tipoMetrica:1 }).toPromise();
      console.log(this.listMetricas);
      this.cargando = false;
    }catch(error){
      this.cargando = false;
      console.log(error);
    }
  }

  checkTodoList(item) {
    if (item.checked) {
      item.checked = false;
    } else {
      item.checked = true;
    }
  };

  doTextareaValueChange(ev) {
    try {
      this.tareaSeleccionada.motivo = ev.target.value;
    } catch(e) {
    }
  }
  modalCancelar(modal, tarea){
    this.tareaSeleccionada = tarea;
    this.modalService.open(modal, { size: 'lg' }) 
  }
}
